import { defineSseEvent } from '@terra/shared-sse-contracts';
import { z } from 'zod';
import { PdfJobStatusSchema } from './pdf-generator.schema';

export const PDF_GENERATION_PROGRESS_SSE_TYPE =
  'pdf_generation_progress' as const;
export const PDF_FINDINGS_EXPORT_PROGRESS_SSE_TYPE =
  'pdf_findings_export_progress' as const;

export const PdfGenerationSsePayloadSchema = z.object({
  jobId: z.string(),
  status: PdfJobStatusSchema,
  progress: z.number(),
  message: z.string(),
  downloadUrl: z.string().optional(),
  error: z.string().optional(),
});

export const PDF_GENERATION_PROGRESS_SSE_EVENT = defineSseEvent({
  type: PDF_GENERATION_PROGRESS_SSE_TYPE,
  payload: PdfGenerationSsePayloadSchema,
  channelPrefix: 'pdf-generation',
  channelKey: ({ jobId }) => jobId,
});

export const PDF_FINDINGS_EXPORT_PROGRESS_SSE_EVENT = defineSseEvent({
  type: PDF_FINDINGS_EXPORT_PROGRESS_SSE_TYPE,
  payload: PdfGenerationSsePayloadSchema,
  channelPrefix: 'pdf-findings-export',
  channelKey: ({ jobId }) => jobId,
});

export type PdfGenerationSsePayload = z.infer<
  typeof PdfGenerationSsePayloadSchema
>;
